import React, { Component } from 'react'
import { Col, Radio, Button,Badge } from 'antd'
import { app, api, config } from '../../app'

// 组件导入
import ReTeamApplicationAuditCom from './ReTeamApplicationAudit/ReTeamApplicationAuditCom'   //筹备组申请

class ReTeamApplicationAudit extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        this.state = {
            sub_type: '1',
            page: 1,
            ApplicationAuditCom: 0
        }
        this.getAllExamineInfoNumber()

    }

    componentDidMount() {
    }

    getAllExamineInfoNumber = () => {
        //获取筹备组申请审核总条数
        app.post(api.TeamApplyAuditCount, {
            indexno: app.getData('indexno'),
            account: app.getData('account')
        }).then(res => {
            console.log(res)
            this.setState({
                ApplicationAuditCom: res.data.team_prep_count
            })
        })
    }

    handleChangeSub = async (sub_type) => {
        // console.log("开始修改队伍")

        await this.setState({ sub_type })
    }

    // 修改当前所在page页
    setPage(page) {
        //把子组件传递过来的值赋给this.state中的属性
        this.setState({
            page: page
        });
    }

    // 页面渲染区
    render() {
        let { sub_type, page } = this.state
        let content_node = null
        let content_title = "无"

        switch (sub_type) {
            case '1':
                content_title = "筹备组申请"
                content_node = (<ReTeamApplicationAuditCom page={page} setPage={this.setPage.bind(this)} />)
                break
            // case '2':
            //     content_title = "筹备队申请"

            //     break
            // case '3':
            //     break

        }
        return (
            <div className="teamApplication" style={{ padding: 30,height:'100%',overflow:'auto'}}>
                <div>
                    <div className="headerNav" style={{ display: 'flex', justifyContent: 'space-between', }}>
                        <Col  >
                            <Radio.Group value={sub_type} buttonStyle="solid" className="no-select"
                                onChange={(e) => this.setState({ sub_type: e.target.value })}>
                                <div style={{ position: 'reletive' }}>
                                    <Badge count={this.state.ApplicationAuditCom || 0} >

                                        {/* <div style={{ position: 'absolute', top: -8, right: -4, color: '#fff', zIndex: 99, width: 20, height: 20, backgroundColor: 'red', textAlign: 'center', lineHeight: '15px', borderRadius: '50%', borderStyle: 'solid', borderBlockColor: 'white', borderBlockEndWidth: 1 }}>{this.state.ApplicationAuditCom}</div> */}
                                        <Radio.Button value="1" >筹备组申请审核</Radio.Button>
                                    </Badge>
                                </div>
                                {/* <Radio.Button value="2" >筹备组转筹备队申请审核</Radio.Button> */}
                                {/* <Radio.Button value="3" >筹备队转正式队申请审核</Radio.Button> */}
                            </Radio.Group>
                        </Col>


                    </div>
                </div>


                <div style={{ padding: 30,height:'100%'}}>
                    {
                        content_node
                    }
                </div>

            </div>

        )
    }
}



export default ReTeamApplicationAudit



// WEBPACK FOOTER //
// ./src/routes/review/ReTeamApplicationAudit.jsx